import React, { useEffect, useRef } from 'react'
import { NavLink, useLocation } from 'react-router-dom'

import images from '../images'
import { normalizeLinkCase } from '../modules'

const Sidebar = ({ stations, sidebarOpen, setSidebarOpen }) => {
    const location = useLocation()
    const split = location.pathname.split('/')
    const page = split[2]

    const trigger = useRef(null)
    const sidebar = useRef(null)

    const close = () => setSidebarOpen(false)

    useEffect(() => {
        const clickHandler = ({ target }) => {
            if (!sidebar.current || !trigger.current) return
            if (!sidebarOpen || sidebar.current.contains(target) || trigger.current.contains(target)) return
            close()
        }
        document.addEventListener('click', clickHandler)
        return () => document.removeEventListener('click', clickHandler)
    })

    // close if the esc key is pressed
    useEffect(() => {
        const keyHandler = ({ keyCode }) => {
            if (!sidebarOpen || keyCode !== 27) return
            close()
        }
        document.addEventListener('keydown', keyHandler)
        return () => document.removeEventListener('keydown', keyHandler)
    })

    return (
        <div className="">
            {/* Sidebar backdrop (mobile only) */}
            <div onClick={ close } className={`fixed inset-0 bg-gray-900 bg-opacity-30 z-40 transition-opacity duration-200 ${sidebarOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} aria-hidden="true"></div>

            {/* Sidebar */}
            <div
                id="sidebar"
                ref={sidebar}
                className={`absolute z-40 left-0 top-0 transform h-screen overflow-y-scroll lg:overflow-y-auto no-scrollbar w-64 flex-shrink-0 bg-gray-800 p-4 transition-transform duration-200 ease-in-out ${sidebarOpen ? 'translate-x-0' : '-translate-x-64'}`}
            >

                {/* Sidebar header */}
                <div className="flex mb-5 pr-3 sm:px-2">
                    <img src={ images.logoLight } className="w-28 self-center sidebar-logo" />
                </div>
                <div>
                    <h3 className="text-xs uppercase text-gray-500 font-semibold pl-3">Menu</h3>
                    <ul className="mt-3">
                        {
                            stations.map(station =>
                                <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${page === station.name && 'bg-gray-900'}`}>
                                    <NavLink onClick={ () => close() } to={ `/app/${station?.name}` } className={`block text-gray-200 hover:text-white transition duration-150 ${page === station.name && 'hover:text-gray-200'}`}>
                                        <div className="flex flex-grow">
                                            <span className="text-sm font-medium">{ normalizeLinkCase(station.name) }</span>
                                        </div>
                                    </NavLink>
                                </li>
                            )
                        }
                    </ul>
                </div>

            </div>
        </div>
    )
}

export default Sidebar